import clientImg from '../img/client.svg';
import inTouch from '../img/intouch.svg';
import Sendmail from '../anexo/sendemail';
import whatsapp from '../img/whatsapp.png';
import gmail from '../img/gmail.png';

export default function Client(){

    return(
        <section className='clients'>
            <div>
                <div className='tips-img'>
                    <img src={clientImg} alt='' className='imgtips'/>
                    <div className='Tips'>
                        <h3 className='sectionTitle' id='clients'> {"Hello there :)"} </h3>
                        <div>
                            <p>
                                <b> Searching for Web development services ? </b>                
                            </p>
                            <p>
                                Sometimes it's hard to know what we need to make our business
                                grow, wich tecnologies should be used and how much will it cost.
                                Get detailed intel it's even more difficult when the internet it's saying
                                so many trivial and meaningless things from what we asked. However, I can help you.
                            </p>
                        </div>
                    </div>
                </div>

                <br/>
                <br/>

                {
                    /** 
                     * 
                     * <section className='mailbox'>
                     * <div>
                     * <strong className='sectionTitle'> Get in touch </strong>
                     * <img src={inTouch} alt=''/>
                     * </div>
                     * <Sendmail/>
                     * </section>
                     * 
                      */
                }
                
            </div>  
            
            <svg className='wave3' xmlns="http://www.w3.org/2000/svg" viewBox="0 100 1440 220"><path fill="#ffffff" fill-opacity="1" d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,250.7C960,267,1056,245,1152,250.7C1248,256,1344,288,1392,304L1440,320L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>

        </section>
    );
}